import { jsx as i } from "react/jsx-runtime";
import { S as a } from "./index-B_6_jmOO.js";
import { c as d } from "./index-CYpVUGdk.js";
import { $ as u } from "./utils-CTvPli9r.js";
import { forwardRef as c } from "react";
const m = d(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring active:bg-secondary disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-secondary/50 hover:text-primary-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), f = c(
  ({ className: e, variant: r, size: o, asChild: t = !1, ...n }, s) => /* @__PURE__ */ i(t ? a : "button", { className: u(m({ variant: r, size: o, className: e })), ref: s, ...n })
);
f.displayName = "Button";
export {
  f as Button,
  m as buttonVariants
};
//# sourceMappingURL=button.js.map
